import styled, { createGlobalStyle, css } from 'styled-components/macro';
import { COLORS } from '@podiumhq/design-system';
import { MEDIUM_MEDIA_QUERY_WIDTH } from '../../styles';

export const TRIAL_COLORS = {
  darkText: '#292E36',
  darkBoldText: '#12151A',
  lightGrey: '#e0e6ee',
  lightGreyText: '#555c67',
  grey: '#9EA9B8',
  validGreen: '#48C78C',
};

export const TrialsLink = styled.a`
  color: ${COLORS.blue.base};
  text-decoration: none;
`;

const CenterContentStyles = css`
  margin: 0 auto;
  max-width: 400px;
`;

export const TrialsPageWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  padding: 32px 32px 24px 32px;
  width: 100%;
`;

export const TrialsPageHeaderWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin: 32px 0 0 42px;
  max-width: 100%;

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    margin: 0 0 12px 0;
  }
`;

export const TrialsPageContentWrapper = styled.div`
  ${CenterContentStyles};

  height: 100%;
  margin-bottom: 30px;
`;

export const TrialsPageFooterWrapper = styled.div`
  ${CenterContentStyles};

  align-self: end;
  color: ${TRIAL_COLORS.lightGreyText};
  font-size: 12px;
  line-height: 150%;
  margin-top: auto;
  text-align: center;
  width: 100%;
`;

export const TrialsGlobalStyles = createGlobalStyle`
  body {
    margin: 0;
  }
`;
